import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteColor = function SvgRteColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#5C5F62",
    d: "M14.445 14.442l-.653-1.942h-3.584l-.653 1.942a.792.792 0 01-1.02.511c-.416-.152-.636-.627-.49-1.062l2.668-7.94C10.904 5.381 11.42 5 12 5s1.096.382 1.287.951l2.668 7.94c.146.435-.074.91-.49 1.062a.792.792 0 01-1.02-.511zM12 7.165l1.232 3.668h-2.464L12 7.165zM19 19v-2H5v2h14z",
    clipRule: "evenodd"
  })));
};
var rteColor = SvgRteColor;

export { rteColor as default };
